import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { useStyles } from '../adminStyles';
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,Checkbox, FormControlLabel
} from '@material-ui/core';
import { Autocomplete,createFilterOptions } from '@material-ui/lab';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { getProjectList} from '../../../redux/projects/projectsActions';
  import {getOnboardingTypes} from '../../../redux/appUsers/appUserActions';
import NotesDialogue from './components/NotesDialogue';
import {
  fetchTaskReport,
  fetchAllActiveProjects,
  fetchTaskReportsCsv,
} from '../../../redux/timesheets/timesheetsActions';
import {
  getClientManagers
} from '../../../redux/appUsers/appUserActions';
import {
  DB_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  EMPLOYEE_TYPE,
} from '../../../redux/constants';

import ExcelExport from './components/ExportExcel';
import SummaryTable from './components/SummaryTable';
const columns = [ 
{ id:'userName', label:'Employee', align:'center'},
{ id:'managerName', label:'Manager', align:'center'},
{ id:'milestoneId', label:'Milestone Id', align:'center'},
{ id: 'regularHrs', label: 'Regular', align: 'center' },
{ id: 'sickHrs', label: 'Sick', align: 'center' },
{ id: 'vacationHrs', label: 'Vacation', align: 'center' },
{ id: 'holidayHrs', label: 'Holiday', align: 'center' },
{ id: 'bereavementHrs', label: 'Bereavement', align: 'center' },
{ id: 'totalHrs', label: 'Total Hours', align: 'center' },
{ id: 'details', label: 'Notes', align: 'center' },
];

const TaskReport = () => {
  document.title = 'Sciata Summaries';
  const {
    approveBtn,
    gridElRight,
    inputMobile,
    btnMobile2,
  } = useStyles();

  const dispatch = useDispatch();
  const [orderAscending, setOrderAscending] = useState(true);
  const taskList=useSelector(state=>state.timesheets.taskList||[])
  const projectsList = useSelector(state => state.projects.allProjects || []);
  const [clientManagers, setClientManagers]=useState([]);
  const [asc, setAsc] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState([]); 
  const [selectedUser, setselectedUser] = useState("");
  const [notesObj, setNotesObj] = useState([]);
  const [onboardingTypes,setOnboardingTypes]=useState([]);
  const [fromDate, setFromDate] = useState(moment().format(DB_DATE_FORMAT));
  const [toDate, setToDate] = useState(moment().format(DB_DATE_FORMAT));
  const [project, setProject] = useState({ name: '', code: 0 });
  const [render, setRender] = useState(false);
  const [openToDate, setOpenToDate] = useState(false);
  const [empType, setEmpType] = useState('ALL');
  const [detailOpen, setDetailOpen] = useState(false); 
  const [milestones,setMilestones]=useState([]);
  const handleDetailClose = () => setDetailOpen(false);
  const [record, setRecord] = useState(0);
  const [searchObject,setSearchObject]=useState({
    projectId:0,
    fromDate: fromDate,
    milestoneRecId:0,
    toDate: toDate,
    byManager:record,
    onboardingTypeId:0
  });
  const renderManagerList = () => {
    return clientManagers.map(manager => (
      <MenuItem value={manager.id}>{`${manager.name}`}</MenuItem>
    ));
  };

  useEffect(() => {   
    bindProjects();
   bindClientManagers()
   bindOnboardingTypes();
   dispatch(
    fetchTaskReport({...searchObject})
  );
  }, []);

  const rowData = {
    timesheets: [],
  };
  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 500);
  }, []);
  const bindProjects = () => dispatch(getProjectList());
  const bindOnboardingTypes= async()=>{
    let _types = await dispatch(getOnboardingTypes());
    setOnboardingTypes(_types);
  }

  const handleDetailOpen = (userObject,userName) => {
    setDetailOpen(true);
    setNotesObj(userObject);
    setselectedUser(userName);
  };
  const bindClientManagers= async()=>{
    let _clientManagers = await dispatch(getClientManagers());
    setClientManagers(_clientManagers);
  }

  const handleGo = () => {
    dispatch(
      fetchTaskReport({...searchObject})
    );
    setAllRecord(false);
    setRecStatus(false);
  };
  useEffect(() => {
    taskList &&
      Array.isArray(taskList) &&
      taskList.forEach(user => {
        rowData.timesheets.push({
            milestoneId:user.milestoneId,
            managerName:user.managerName,
            userName:user.userName,
            details:user.tasks||[],
            sickHrs: user.sickHrs,
            vacationHrs: user.vacationHrs,
            holidayHrs: user.holidayHrs,
            regularHrs: user.regularHrs,
            bereavementHrs:user.bereavementHrs,
            totalHrs: user.totalHrs,
            note:""
        });
      });
    setRows(rowData.timesheets || []);
  }, [taskList]);

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: option => (option.projectName+" "+option.client),
  });

  const exportCsv = async (start, end, type) => {
    await dispatch(
      fetchTaskReportsCsv({
        ...searchObject
      })
    );
  };

  const sortArray = (arr, property) => () => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');

    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = (a.userName || '').toString().toUpperCase();
          let nameB = (b.userName || '').toString().toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const selectAll = (rows,e)  => {
    let array = [...rows];
    array.forEach((user,index) => {
      array[index].isChecked=e.target.checked
    });
    setRows(array);
    handleCheck();
    setAllRecord(e.target.checked);
  };
  const onFieldChange = e => {
    setRecord(parseInt(e.target.value||0));
    setSearchObject({...searchObject, byManager:parseInt(e.target.value||0)});
  };
  const selectByIndex = (rows, e,index) => {
    let array = [...rows];
    array[index].isChecked = e.target.checked
    setRows(array);
    handleCheck();
    setAllRecord(false);
  };

  const handleCheck = () => {
     setRecStatus((rows||[]).some(item => item.isChecked === true));
  }
  const [pId, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState('');
  const [isRecSelected, setRecStatus] = React.useState(false);
  const [allRecord, setAllRecord] = React.useState(false);

  const summaryTableProps = {
    columns,
    rows,
    sortArray,
    selectAll,
    selectByIndex,
    handleDetailOpen,
    orderAscending,
    isRecSelected,
    asc,
    searchTerm,
    allRecord,
    employeeType: empType,
  };
  const taskNotesProps = {
    notesObj,
    detailOpen,
    handleDetailClose,
    selectedUser
  };
  return (
    <>
      <h1>Task Report</h1>
      <Grid container justify='center' alignItems='center' spacing={1}> 
        <Grid item xs={4} >
        
                  <Autocomplete
                    onChange={(event, newValue) => {
                      searchObject.projectId=newValue==null?"0":newValue.projectId;
                      setMilestones(((newValue||{}).milestones||[]));
                      setSearchObject(searchObject);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    filterOptions={filterOptions}
                    id="controllable-states-demo"
                    getOptionLabel={(option) => (option.client||"")==""?(option.projectName||""):(option.projectName||"")+"["+(option.client||"")+"]"}
                    options={projectsList}
                    style={{ width: '100%' }}
                    renderInput={(params) =>{
                      return (
                                <TextField {...params} label="Project" variant="outlined" />
                        )
                    } }
                  />
                  

                </Grid> 
                <Grid item xs={2} >
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-milestoneRecId'>
                    Milestone
                    </InputLabel>
                    <Select  style={{width:'100%'}}
                    labelId='select-label-milestoneRecId' 
                      name="milestoneRecId"
                      variant='outlined'
                      label='Milestone'
                      value={searchObject.milestoneRecId}
                      onChange={(e)=>{
                        searchObject.milestoneRecId=e.target.value;
                        setSearchObject({...searchObject});
                      }}>
                      <MenuItem value={0}>All</MenuItem>
                      {
                        milestones.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{`${item.milestoneId} ${item.descreption}`}</MenuItem>
                        })
                      }
                    </Select>
                    </FormControl>
                </Grid>      
        
        <Grid item xs={12} md={3}>
                  <FormControl  fullWidth>
                    <InputLabel variant='outlined' id='select-label-managerId'>
                      Client Manager
                    </InputLabel>
                    <Select
                      labelId='select-label-managerId'
                      label='Client Manager'
                      name='managerId'
                      variant='outlined'
                      value={record}
                      id='manager'
                      onChange={onFieldChange}
                    >{<MenuItem value={0}>{"All"}</MenuItem>}
                      {renderManagerList()}
                    </Select>
                  </FormControl>
          </Grid>
          
                
                <Grid item xs={2}>
                <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-onboardingTypeId'>
                    Onboarding Type
                    </InputLabel>
                    <Select style={{width:'100%'}}
                      labelId='select-label-onboardingTypeId'
                      label='Onboarding Types'
                      name='onboardingTypeId'
                      variant='outlined'
                      value={searchObject.onboardingTypeId || 0}
                      id='onboardingTypeId'
                      onChange={(e)=>{
                        searchObject.onboardingTypeId=e.target.value;
                        setSearchObject({...searchObject});
                      }}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {
                        onboardingTypes.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{item.name}</MenuItem>
                        })
                      }                      
                    </Select>
                  </FormControl>
                </Grid>
      
        <Grid container item xs={12} md={6} spacing={1}>
          <Grid item md={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                label='From Date'
                value={moment(fromDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(true);
                  setFromDate(date);
                  setSearchObject({...searchObject, fromDate:date})
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item md={4}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                open={openToDate}
                label='To Date'
                value={moment(toDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(false);
                  setToDate(date);
                  setSearchObject({...searchObject, toDate:date})
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <ExcelExport  approveBtn={approveBtn} {...summaryTableProps} />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button className={btnMobile2} onClick={handleGo} variant='contained'>
              Go
            </Button>
          </Grid>         
        
        </Grid>
      </Grid>
      <SummaryTable {...summaryTableProps} />
      <NotesDialogue {...taskNotesProps} />
    </>
  );
};

export default TaskReport;
